// localStorage-backed handle for an in-flight reel publish job, so that a
// WebView-killed tab can resume polling on the next mount.

const STORAGE_KEY = 'reels.activeJob.v1';
const STALE_AFTER_MS = 10 * 60_000;

export interface ActiveJob {
  jobId: string;
  batchId: string;
  accountIds: string[];
  startedAt: number;
}

function isActiveJob(value: unknown): value is ActiveJob {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.jobId === 'string' &&
    typeof v.batchId === 'string' &&
    Array.isArray(v.accountIds) &&
    v.accountIds.every((id) => typeof id === 'string') &&
    typeof v.startedAt === 'number'
  );
}

export function saveActiveJob(job: ActiveJob): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(job));
  } catch {
    // Quota / disabled storage — best effort.
  }
}

export function loadActiveJob(): ActiveJob | null {
  let raw: string | null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!isActiveJob(parsed)) return null;
  if (Date.now() - parsed.startedAt > STALE_AFTER_MS) return null;
  return parsed;
}

export function clearActiveJob(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // best effort
  }
}
